import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import * as S from './AndroidAppBanner.styles';
import NoSsr from '@/components/NoSsr/NoSsr';
import { useAndroidBannersStore } from '@/store/useBannerStore/useAndroidBannerStore';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export const AndroidAppBanner = () => {
  const [isAndroidBannerVisible, setIsAndroidBannerVisible] =
    useAndroidBannersStore(state => [
      state.isAndroidBannerVisible,
      state.setIsAndroidBannerVisible,
    ]);
  const { isWebView } = useBridgeState();
  const { t } = useTranslation();
  const hostnameModified =
    typeof window !== 'undefined' &&
    `.${window.location.hostname?.replace(/^ru./, '')}`;

  function handleCloseClick() {
    Cookies.set('appBannerShow', 'true', {
      expires: 7,
      domain: hostnameModified || '',
    });
    setIsAndroidBannerVisible(false);
  }

  useEffect(() => {
    setIsAndroidBannerVisible(!isWebView && !Cookies.get('appBannerShow'));
  }, [isWebView]);

  return (
    isAndroidBannerVisible && (
      <NoSsr>
        <S.BannerContainer>
          <S.BannerClose onClick={handleCloseClick}>close</S.BannerClose>
          <S.Banner>
            <IconBox
              $filename="app_banners/app-banner-logo.png"
              $width={30}
              $height={30}
              $iconWidth={30}
              $iconHeight={30}
            />
            <S.BannerText>
              {t('banners.app_banner_title')}
              <S.BannerDescription>
                {t('banners.app_banner_desc')}
              </S.BannerDescription>
            </S.BannerText>
          </S.Banner>
          <S.BannerLink
            href="intent://tap.az/#Intent;scheme=tapaz;package=org.tapaz.android;end"
            onClick={handleCloseClick}
          >
            {t('banners.app_banner_open')}
          </S.BannerLink>
        </S.BannerContainer>
      </NoSsr>
    )
  );
};

AndroidAppBanner.displayName = 'AndroidAppBanner';
